<template>
  <div class="trash-view">
    <app-view-layout
      fluid
      header="Usunięte projekty"
    >
      <template #content>
        <AppSearchInput
          class="mb-4"
          search-placeholder="Wyszukaj"
          @search="filterElements({ query: $event })"
        />

        <v-data-table
          class="view-table"
          :headers="staticData.headers"
          :items="projectsList"
          fixed-header
          show-expand
          single-expand
          no-result-text="Brak pasujących projektów"
          no-data-text="Brak projektów w koszu"
          :loading="isLoading"
          loading-text="Wyszukiwanie projektów"
          :items-per-page="-1"
          hide-default-footer
          :footer-props="{
            itemsPerPageOptions: [12,24,36],
            itemsPerPageText: 'Pozycji na stronę',
          }"
        >
          <template #item="{ item }">
            <ProjectsTableRow
              :project="item"
              trash-view
              @delete="confirmPermanentDeleteProject(item.id)"
              @bringBack="confirmBringingProjectBack(item.id)"
            />
          </template>

          <template #no-results>
            <AppEmptyList class="trash-view__empty py-10" />
          </template>
        </v-data-table>

        <AppPagination @change="fetchProjects" />
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import ProjectCard from '@/components/Projects/ProjectCard.vue';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';
import AppSearchInput from '@/components/UI/AppSearchInput.vue';
import AppPagination from '@/components/UI/AppPagination.vue';
import ProjectsTableRow from '@/components/Projects/ProjectsTableRow.vue';

const headers = [
  { text: 'Nazwa projektu', value: 'name', sortable: false },
  { text: 'ID projektu', value: 'id', sortable: false },
  { text: 'Czas realizacji', value: 'projectPeriod', sortable: false },
  { text: 'Kampanie', value: 'campaigns', sortable: false }, // tod
  { text: 'Typ projektu', value: 'projectType', sortable: false },
  { text: 'Zespół projektowy', value: 'members', sortable: false },
  { text: 'Zespół zlecający', value: 'orderers', sortable: false },
  { text: 'Status', value: 'status', sortable: false },
  { text: '', value: 'trashActions', sortable: false },
];

export default {
  components: {
    AppViewLayout,
    ProjectCard,
    AppEmptyList,
    AppPagination,
    AppSearchInput,
    ProjectsTableRow,
  },

  data: () => ({
    searchQuery: '',
    staticData: {
      headers,
    },
  }),

computed: {
    ...mapState('projects', [
      'projectsList',
    ]),
    ...mapState(['isLoading']),
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.resetProjects();
      vm.setFilters({ softDeleted: true });
      vm.fetchProjects();
    });
  },

  methods: {
    ...mapActions('projects', [
      'fetchProjects',
      'resetProjects',
      'deleteProjectPermanently',
      'bringProjectBack',
    ]),

    ...mapActions('dialog', [
      'showDialog',
      'clearDialog',
    ]),

    ...mapActions('filters', [
      'setFilters',
    ]),

    filterElements(filterObject) {
      this.setFilters(filterObject)
        .then(() => {
          this.fetchProjects();
        });
    },

    callConfirmDialog(config, callback, id) {
      this.showDialog({
        component: 'Confirm',
        ...config,
      })
        .then(() => {
          callback(id).then(() => {
            this.fetchProjects();
          });
        })
        .catch(() => {
          this.clearDialog();
        });
    },
    confirmPermanentDeleteProject(id) {
      const config = {
        header: 'Trwałe usuwanie projektu',
        text: 'Czy na pewno chcesz trwale usunąć projekt?',
        props: {
          confirmText: 'Usuń',
          rejectText: 'Nie usuwaj',
        },
      };
      this.callConfirmDialog(config, this.deleteProjectPermanently, id);
    },
    confirmBringingProjectBack(id) {
      const config = {
        header: 'Przywracanie projektu',
        text: 'Czy na pewno chcesz przywrócić ten projekt?',
        props: {
          confirmText: 'Przywróć',
          rejectText: 'Nie przywracaj',
        },
      };
      this.callConfirmDialog(config, this.bringProjectBack, id);
    },
  },
};
</script>

<style lang="scss" scoped>
.trash-view {
  &__empty {
    min-height: calc(100vh - 220px);
  }
  .view-table::v-deep  .v-data-table__wrapper {
    max-height: calc(100vh - 300px);
  }
}
</style>
